
    <!--
 * 横版-兑换奖励
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_699X21"  :class="[`normal exchange-page`,`u_c_699X21`]" ><div id="u_c_EKYK26"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_EKYK26`]" ></div><div id="u_c_VWXA17"  v-html="compData.subTitle" :class="[`normal`,`u_c_VWXA17`]" ></div><div id="u_c_ZIK217"  :class="[`normal`,`u_c_ZIK217`]" ><span id="u_c_W98X20"  :class="[`normal txt `,`u_c_W98X20`]" >{{`${ langData.myLotteryTime }:`}}</span><span id="u_c_G4O1243"  :class="[`normal txt lottery-total-time`,`u_c_G4O1243`]" >{{`${ pageData.lotteryTime }`}}</span><a id="u_c_CIC422" href="javascript:;" :class="[`normal txt `,`u_c_CIC422`]" @click="u_c_CIC422_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_97GI24"  :class="[`normal`,`u_c_97GI24`]" ><div id="u_c_G7XP20"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-prev-btn btn-light rtl-trans`,`u_c_G7XP20`]" ></div><div id="u_c_BUC617"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-next-btn btn-light `,`u_c_BUC617`]" ></div><swiper id="u_c_QZNF17"  :navigation="({
    nextEl: '.swiper-button-next-btn',
    prevEl: '.swiper-button-prev-btn'
})" :modules="modules" :slides-per-view="1" :class="[`normal`,`u_c_QZNF17`]" ><template   v-for="(slideItem, slideIndex) in compData.exchangeInfo" :key="slideIndex" ><swiper-slide id="u_c_HAC518"  v-if="!(slideIndex % compData.count) && !pageData.isEdit || pageData.isEdit && +slideIndex == 0" :class="[`normal`,`u_c_HAC518`]" ><div id="u_c_QWQK19"  v-for="(exchangeItem, eIndex) in compData.exchangeInfo" :key="eIndex" :class="[`normal`,`u_c_QWQK19`]" ><div id="u_c_LJFK25"  :data-index="exchangeItem.use" v-if="eIndex >= +slideIndex && eIndex < +slideIndex + +compData.count" :class="[`normal  `,`u_c_LJFK25`]" ><div id="u_c_51RC62"  :class="[`normal btn-light award-btn`,`u_c_51RC62`]" @click="u_c_51RC62_event_00RH18($event,eIndex)"><div id="u_c_VZ9X63"  :class="[`normal txt `,`u_c_VZ9X63`]" >{{`${ langData.exchangeUse }`}}<div id="u_c_LTU465"  :class="[`normal txt lottery-time`,`u_c_LTU465`]" >{{`${ exchangeItem.use }`}}</div></div><div id="u_c_7T3N26"  :style="`background-image:url(${ exchangeItem.pic })`" :class="[`normal`,`u_c_7T3N26`]" ></div><div id="u_c_SJW828"  v-show="exchangeItem.state == 2 || exchangeItem.state == void 0 && eIndex == 0" :class="[`normal gou`,`u_c_SJW828`]" ></div></div></div></div></swiper-slide></template></swiper></div><a id="u_c_NS5318" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light  page-common-btn exchange-award-btn`,`u_c_NS5318`]" @click="u_c_NS5318_event_8J5W26($event)"><div id="u_c_WSMK19"  :class="[`normal page-common-btn`,`u_c_WSMK19`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import { Swiper, SwiperSlide } from "swiper/vue";import { Navigation } from "swiper";import "swiper/css";import "swiper/css/navigation"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"exchangeInfo":[{"name":"兑换奖励1\n兑换奖励1-1","use":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励2\n兑换奖励2-2","use":"10","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励3\n兑换奖励3-3","use":"15","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"20张券","use":"20","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"25张券","use":"25","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"30张券","use":"30","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"35张券","use":"35","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"40张券","use":"40","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"45张券","use":"45","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"50张券","use":"50","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"55张券","use":"55","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"60张券","use":"60","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"65张券","use":"65","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"70张券","use":"70","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"75张券","use":"75","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"80张券","use":"80","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"85张券","use":"85","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"90张券","use":"90","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"95张券","use":"95","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"100张券","use":"100","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"}],"subTitle":`活动期间，在【天使的选择】中累计消耗抽奖券进行抽奖，
达到一定次数后即可免费领取对应奖励（次数不会重置）`,"count":8,"title":`成神祝福赠礼`},"en-US":{"exchangeInfo":[{"name":"Dragon Orbs (Unique)*1\nWarrior's Jadeite*1\nGarnet Jewel*100","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301654529223.png"},{"name":"Eagle's Cookie*1\nCriticality Stone(Advanced)*5\nJewel of Life*5","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301683910979.png"},{"name":"Jewel of Luck*1\nAdvanced Benediction*1\nGarnet Jewel*150","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301677083144.png"},{"name":"Follower of Love Costume Choice Package*1\nBurning Obsidian*1\nJewel of Life*8","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192719640380.png"},{"name":"Follower of Love Costume Choice Package*1\nBreath of the Divine Wind (Advanced)*10\nGarnet Jewel*200","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192774772516.png"},{"name":"Follower of Love Costume Choice Package*1\nDragon Orbs (Unique)*1\nJewel of Life*12","use":"80","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192717799946.png"},{"name":"Follower of Love Costume Choice Package*1\nEagle's Cookie*1\nGarnet Jewel*250","use":"120","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192710994246.png"},{"name":"Follower of Love Costume Choice Package*1\nImmortal Crystal*1\nJewel of Life*16","use":"160","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192754488730.png"},{"name":"Follower of Love Off-Hand Weapon Costume Package*1\nIllusion Crystal*1\nGarnet Jewel*300","use":"200","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216426690722.png"},{"name":"Follower of Love Main Hand Weapon Costume Package*1\nFeather of Condor*1\nJewel of Life*20","use":"250","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216417734637.png"}],"subTitle":`Corresponding rewards will be unlocked when the total number of Lucky Tickets you use reaches a certain amount.`,"count":8,"title":`Bonus Gift`},"ru-RU":{"exchangeInfo":[{"name":"Драконьи шары (Уникальные)*1\nЖадеит Воина*1\nСамоцвет Граната*100","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301654529223.png"},{"name":"Печенье Орла*1\nКамень критичности (Усиленный)*5\nСамоцвет Жизни*5","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301683910979.png"},{"name":"Самоцвет Удачи*1\nУсиленное благословение*1\nСамоцвет Граната*150","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301677083144.png"},{"name":"Набор на выбор костюма Последователя любви*1\nГорящий Обсидиан*1\nСамоцвет Жизни*8","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192719640380.png"},{"name":"Набор на выбор костюма Последователя любви*1\nДыхание Божественного Ветра (Усиленное)*10\nСамоцвет Граната*200","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192774772516.png"},{"name":"Набор на выбор костюма Последователя любви*1\nДраконьи шары (Уникальные)*1\nСамоцвет Жизни*12","use":"80","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192717799946.png"},{"name":"Набор на выбор костюма Последователя любви*1\nПеченье Орла*1\nСамоцвет Граната*250","use":"120","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192710994246.png"},{"name":"Набор на выбор костюма Последователя любви*1\nБессмертный Кристалл*1\nСамоцвет Жизни*16","use":"160","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192754488730.png"},{"name":"Костюм для дополнительного оружия \"Последователь любви\" (набор)*1\nКристалл иллюзий*1\nСамоцвет Граната*300","use":"200","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216426690722.png"},{"name":"Костюм для основного оружия \"Последователь любви\" (набор)*1\nПеро Кондора*1\nСамоцвет Жизни*20","use":"250","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216417734637.png"}],"subTitle":`Corresponding rewards will be unlocked when the total number of Lucky Tickets you use reaches a certain amount.`,"count":8,"title":`Bonus Gift`},"pt-PT":{"exchangeInfo":[{"name":"Orbes de Dragão (Único)*1\nJadeíta do Guerreiro*1\nJoia de Granada*100","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301654529223.png"},{"name":"Biscoito da Águia*1\nPedra de Criticidade (Avançada)*5\nJoia da Vida*5","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301683910979.png"},{"name":"Joia da Sorte*1\nBenção Avançada*1\nJoia de Granada*150","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944301677083144.png"},{"name":"Pacote de Escolha de Traje Seguidor do Amor*1\nObsidiana Ardente*1\nJoia da Vida*8","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192719640380.png"},{"name":"Pacote de Escolha de Traje Seguidor do Amor*1\nSopro do Vento Divino (Avançado)*10\nJoia de Granada*200","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192774772516.png"},{"name":"Pacote de Escolha de Traje Seguidor do Amor*1\nOrbes de Dragão (Único)*1\nJoia da Vida*12","use":"80","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192717799946.png"},{"name":"Pacote de Escolha de Traje Seguidor do Amor*1\nBiscoito da Águia*1\nJoia de Granada*250","use":"120","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192710994246.png"},{"name":"Pacote de Escolha de Traje Seguidor do Amor*1\nCristal Imortal*1\nJoia da Vida*16","use":"160","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192754488730.png"},{"name":"Pacote de Traje de Arma Secundária do Seguidor do Amor*1\nCristal de Ilusão*1\nJoia de Granada*300","use":"200","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216426690722.png"},{"name":"Pacote de Traje de Arma Principal do Seguidor do Amor*1\nPena do Condor*1\nJoia da Vida*20","use":"250","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173944216417734637.png"}],"subTitle":`Corresponding rewards will be unlocked when the total number of Lucky Tickets you use reaches a certain amount.`,"count":8,"title":`Bonus Gift`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '兑换奖励';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform;

const init = () => {
  compData.exchangeInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.exchangeList) {
      let confList = _.cloneDeep(compData.exchangeInfo)
      compData.exchangeInfo = []
      value.exchangeList.forEach((item, index) => {
        if (confList[index]) {
          compData.exchangeInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            use: item.send_cost,
            id: item.id,
            name: confList[index].name,
          })
        }
      })
      giftInfo.exchangeAward = compData.exchangeInfo
    }
  }, {
    deep: true
  }
)

init()

const canClickExchange = ref(true)
const exchangeFn = async (id, index) => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'exchangeAward'), {
    params: JSON.stringify({
      id: id,
      language: curLang
    }),
  })
  if (res.result == 1) {
    compData.exchangeInfo[index].state = 2
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value : compData.exchangeInfo[index].name;
    showGetSucc(res.data.send_type, compData.exchangeInfo[index].pic, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 更新按钮的click事件
      const u_c_CIC422_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
        if (!checkIsBind()) return
        if(!canClickRefresh.value)return;
        canClickRefresh.value = false;
        initActivity();
        await utils.sleep(5);
        canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 自定义元素51RC62的click事件
      const u_c_51RC62_event_00RH18= async (e,index)=>{
        try {pageData.seeGift = [compData.exchangeInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_NS5318_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickExchange.value) return;
canClickExchange.value = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "领取兑换奖励",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let curIndex = compData.exchangeInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await exchangeFn(compData.exchangeInfo[curIndex].id, curIndex);
} else {
  let finishIndex = compData.exchangeInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.exchangeInfo.length - 1 ? '-10011' : '-10013',
      getLangTxt('common')
    ),
    ''
  );
}
canClickExchange.value = true;} catch (error) {console.log(error)}
      };const modules = computed(()=> [Navigation])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434306886-5.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.default{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715386566604.png);
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_W98X20.normal{
position:relative;

}
}.default{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.default{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.default{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.default{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520670-98.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.default{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520673-69.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.default{
.u_c_QZNF17.normal{
position:relative;

}
}.default{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.default{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.default{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.default{
.u_c_51RC62.normal{
position:relative;
width:11.88vw;
height:12.81vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
overflow:hidden;

}
}.default{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.25vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.default{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.default{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.default{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.49vw;

}
}.default{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:1.88vw;
font-weight:bold;

}
}.en-US{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434306886-5.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.en-US{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_W98X20.normal{
position:relative;

}
}.en-US{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.en-US{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.en-US{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.en-US{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520670-98.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.en-US{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520673-69.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.en-US{
.u_c_QZNF17.normal{
position:relative;

}
}.en-US{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.en-US{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.en-US{
.u_c_51RC62.normal{
position:relative;
width:11.88vw;
height:12.81vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
overflow:hidden;

}
}.en-US{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.25vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.en-US{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.en-US{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.en-US{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.49vw;

}
}.en-US{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:1.88vw;
font-weight:bold;

}
}.ru-RU{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434306886-5.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ru-RU{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_W98X20.normal{
position:relative;

}
}.ru-RU{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.ru-RU{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.ru-RU{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.ru-RU{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520670-98.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.ru-RU{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520673-69.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.ru-RU{
.u_c_QZNF17.normal{
position:relative;

}
}.ru-RU{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.ru-RU{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.ru-RU{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.ru-RU{
.u_c_51RC62.normal{
position:relative;
width:11.88vw;
height:12.81vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
overflow:hidden;

}
}.ru-RU{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.25vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.ru-RU{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.ru-RU{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ru-RU{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.49vw;

}
}.ru-RU{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:1.88vw;
font-weight:bold;

}
}.pt-PT{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434306886-5.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pt-PT{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_W98X20.normal{
position:relative;

}
}.pt-PT{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.pt-PT{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.pt-PT{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.pt-PT{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520670-98.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.pt-PT{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520673-69.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.pt-PT{
.u_c_QZNF17.normal{
position:relative;

}
}.pt-PT{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.pt-PT{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.pt-PT{
.u_c_51RC62.normal{
position:relative;
width:11.88vw;
height:12.81vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
overflow:hidden;

}
}.pt-PT{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.25vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.pt-PT{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.pt-PT{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.pt-PT{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.49vw;

}
}.pt-PT{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:1.88vw;
font-weight:bold;

}
}
</style>
